import UserService from "./services/UserService";
import ClientService from "./services/ClientService";
import EmployeeService from "./services/EmployeeService";
import BillingService from "./services/BillingService";
import ProjectService from "./services/ProjectService";
import ServicePredict from "./services/ServicePredictService";
import SubscriptionPredict from "./services/SubscriptionPredictService";
import GroupService from "./services/GroupService";
import SettingsService from "./services/SettingsService";
export default {
  UserService: new UserService(),
  ClientService: new ClientService(),
  EmployeeService: new EmployeeService(),
  BillingService: new BillingService(),
  ProjectService: new ProjectService(),
  ServicePredict: new ServicePredict(),
  SubscriptionPredict: new SubscriptionPredict(),
  GroupService: new GroupService(),
  SettingsService: new SettingsService(),
};
